(() => {
  if (window.ddRevolvingClaimSystem) return;

  const SELECTOR = '[data-dd-revolving-claim]';

  const getSections = (root = document) => {
    const sections = root.matches?.(SELECTOR) ? [root] : [];
    return [...sections, ...(root.querySelectorAll?.(SELECTOR) || [])];
  };

  class DDRevolvingClaim extends HTMLElement {
    connectedCallback() {
      this.initialize();
    }

    disconnectedCallback() {
      this.destroy();
    }

    initialize() {
      this.destroy();

      this.claims = [...this.querySelectorAll('[data-dd-revolving-item]')];
      this.activeIndex = this.claims.findIndex((claim) => claim.classList.contains('is-active'));

      if (this.claims.length === 0) {
        this.activeIndex = -1;
        return;
      }

      if (this.activeIndex < 0) this.activeIndex = 0;
      this.setActive(this.activeIndex, { animate: false });

      this.abortController = new AbortController();
      const listenerOptions = { signal: this.abortController.signal };

      this.addEventListener('shopify:block:select', this.handleBlockSelect, listenerOptions);
      this.addEventListener('shopify:block:deselect', this.handleBlockDeselect, listenerOptions);

      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotionQuery.addEventListener('change', this.handleReducedMotionChange, listenerOptions);
      this.startTimer();
    }

    destroy() {
      this.stopTimer();
      this.abortController?.abort();
      this.abortController = null;
      this.reducedMotionQuery = null;
    }

    setActive(index, { animate = true } = {}) {
      if (index < 0 || index >= this.claims.length) return;

      const previousIndex = this.activeIndex;
      this.claims.forEach((claim) => claim.classList.remove('is-active', 'is-exiting'));
      if (animate && previousIndex >= 0 && previousIndex !== index) {
        this.claims[previousIndex].classList.add('is-exiting');
      }
      this.claims[index].classList.add('is-active');
      this.activeIndex = index;
    }

    startTimer() {
      this.stopTimer();

      if (
        !this.isConnected ||
        this.claims.length < 2 ||
        this.dataset.autoplay !== 'true' ||
        this.reducedMotionQuery?.matches
      ) {
        return;
      }

      this.timer = window.setInterval(() => {
        this.setActive((this.activeIndex + 1) % this.claims.length);
      }, Number(this.dataset.speed) || 5000);
    }

    stopTimer() {
      if (this.timer === undefined) return;
      window.clearInterval(this.timer);
      this.timer = undefined;
    }

    handleBlockSelect = (event) => {
      const selectedClaim = event.target.closest?.('[data-dd-revolving-item]');
      const selectedIndex = this.claims.indexOf(selectedClaim);
      if (selectedIndex < 0) return;

      this.stopTimer();
      this.setActive(selectedIndex);
    };

    handleBlockDeselect = () => {
      this.startTimer();
    };

    handleReducedMotionChange = () => {
      this.startTimer();
    };
  }

  if (!customElements.get('dd-revolving-claim')) {
    customElements.define('dd-revolving-claim', DDRevolvingClaim);
  }

  const initializeWithin = (root) => {
    getSections(root).forEach((section) => section.initialize?.());
  };

  const destroyWithin = (root) => {
    getSections(root).forEach((section) => section.destroy?.());
  };

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  document.addEventListener('shopify:section:reorder', (event) => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));

  window.ddRevolvingClaimSystem = true;
})();
